import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";
import * as moment from 'moment';
import { bookingFormCommon } from "../c005-bookingform-common";
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";

export class loginDetails {

    private loginDetails:any   = $('#members--login--details');
    private bookingformcommon = new bookingFormCommon();
    
    $scope: any = $('#members--login--details');
	buttonConnect(): any {
        $('.connect-btn a').click(function () {
            let redirecturl = $(this).attr('data-href');
            var $socialMediaConnectName:any = $(this).parent().attr('data-link');
            let socialMediaConnectObj = {
                'ChangePassword': 'change-password',
                'GoogleConnect': 'connect-google',
                'AppleConnect': 'connect-apple'
            }
            adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Enrich Account Settings',
                'clickName': 'click:btn-click:'+socialMediaConnectObj[$socialMediaConnectName],
                'componentType': 'btn',
                'componentName': 'link connect button',
                'componentID': 'link connect button',
                'attributes': []
            });
            
           window.open(redirecturl, '_blank');         
        });
        $('.pref_settings .otpLoginFlow-btn').click(function() {   
            $.magnificPopup.open({
                items: {
                    src: '#otpLoginFlow-popup'
                },
                type:'inline',
                midClick: true,
                closeBtnInside: false
                });
        });
        $('.pref_settings .otpOtion-btn').click(function() {  
            $.magnificPopup.open({
                items: {
                    src: '#otpOption-popup'
                },
                type:'inline',
                midClick: true,
                closeBtnInside: false
                });
        });
        $('.link_program .linkacc-connect-btn').click(function() {
            let _self = this;
            var $linkname:any = this.getAttribute('data-link');
            let linkObj = {
                'Bonuslink': 'link-bonus',
                'Binfinite': 'link-binfinte',
                'SunwayPals': 'link-sunway-pals',
                'Setal' : 'link-setal'
            }
            adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Enrich Account Settings',
                'clickName': 'click:btn-click:'+linkObj[$linkname],
                'componentType': 'btn',
                'componentName': 'link connect button',
                'componentID': 'link connect button',
                'attributes': []
            });
            if($('#'+$linkname ).find('.linkacc-connect-btn').hasClass('btn-disconnect'))
            {    
            var $linkname:any = this.getAttribute('data-link');    
            $("#cardName").val($linkname);
            $.magnificPopup.open({
                items: {
                    src: '#loginaccount-popup'
                },
                type:'inline',
                midClick: true,
                closeBtnInside: false,
                closeOnBgClick:false
                });
            }
            else if($('#'+$linkname ).find('.linkacc-connect-btn').hasClass('connect-btn'))
            {
                $('#linkcard-number--acc').removeClass('has-error');
                var $linkname:any = this.getAttribute('data-link');
                $("#linkcardName").val($linkname);
                $.magnificPopup.open({
                    items: {
                        src: '#linkaccount-popup'
                    },
                    type:'inline',
                    midClick: true,
                    closeBtnInside: false,
                    closeOnBgClick:false
                    }); 
            }
        });
    }
    editOtpLoginFlow():any{
        $('.white-popuplogin .btn-otpLoginFlow--edit').click((evt: any) => {
            let _self = this;
            var otpLoginVal=$("input:radio.otpLoginflow_edit:checked").val();
            //alert("otpLoginVal>>"+otpLoginVal);
            let data:any = {
                'action':'otpLoginFlow',
                'otpLoginVal' : otpLoginVal
                }
            $("#errorMessagePrefLogin").hide();
            _self.bookingformcommon.preloader();
            $.ajax({
                    type: 'POST',
                    data:data,
                    url: '/bin/services/new/editAcctPrefSettings',
                    success: function(msg:any) {
                    if(typeof msg==='string'){
                    msg = JSON.parse(msg);
                    }else{
                        msg=msg;
                    }
                    if(msg.errorCode=="OK")
                    {
                        _self.bookingformcommon.preloaderClose();
                        $("#succPrefMessage").show();
                        $("#succPrefMessage").removeClass("hide");
                        $('#otpLoginFlow').find('.user-details span').html(msg.dispText);
                        $.magnificPopup.close();              
                    }else{
                       _self.bookingformcommon.preloaderClose();
                        $("#errorMessagePrefLogin").show();
                        $("#succPrefMessage").hide();
                        $.magnificPopup.close();
                    }
                    
                    },
                    error: function(error:any) {
                        _self.bookingformcommon.preloaderClose();
                        $.magnificPopup.close(); 
                        $("#errorerrorMessagePrefLoginMessage").show(); 
                        $("#succPrefMessage").hide();
                    }
                });
        });
        $("#errorMessagePrefLogin").hide();
    }
    editOtpOption():any{
        $('.white-popuplogin .btn-otpOption--edit').click((evt: any) => {
            let _self = this;
            var otpOtionVal=$("input:radio.otpOption_edit:checked").val();
            //alert("otpOtionVal>>"+otpOtionVal);
            let data:any = {
                'action':'otpOption',
                'otpLoginVal' : otpOtionVal
                }
            $("#errorMessagePrefLogin").hide();
            _self.bookingformcommon.preloader();
            $.ajax({
                    type: 'POST',
                    data:data,
                    url: '/bin/services/new/editAcctPrefSettings',
                    success: function(msg:any) {
                    if(typeof msg==='string'){
                    msg = JSON.parse(msg);
                    }else{
                        msg=msg;
                    }
                    if(msg.errorCode=="OK")
                    {
                        _self.bookingformcommon.preloaderClose();
                        $("#succPrefMessage").show();
                        $("#succPrefMessage").removeClass("hide");
                        $('#otpDelvChanel').find('.user-details span').html(msg.dispText);
                        $.magnificPopup.close();              
                    }else{
                       _self.bookingformcommon.preloaderClose();
                         $("#succPrefMessage").hide();
                        $("#errorMessagePrefLogin").show();
                        $.magnificPopup.close();
                    }
                    
                    },
                    error: function(error:any) {
                        _self.bookingformcommon.preloaderClose();
                        $.magnificPopup.close(); 
                        $("#errorerrorMessagePrefLoginMessage").show(); 
                        $("#succPrefMessage").hide();
                    }
                });
        });
        $("#errorMessagePrefLogin").hide();
    }
    linkaccount():any{
        $('.white-popuplogin .btn-loginacc--link').click((evt: any) => {
            let _self = this;
            var cardnumber=$('#linkcard-number--acc').val();
            var card=$("#linkcardName").val();
            if(cardnumber=="")
            {
                $('#linkcard-number--acc').addClass('has-error');
            }
            else{
            $('#linkcard-number--acc').removeClass('has-error');
            let data:any = {
                'card' : card,
                'action':'link',
                'cardnumber' : cardnumber
                }
            $("#errorMessage").hide();
            let linkandunlink: string = '';
            if (window.location.hostname === 'localhost' && window.location.port == "5000") {
                linkandunlink = '/dummy-data/linkandunlink.json';
            }
            else {
                linkandunlink = '/bin/services/new/linkAndUnlinkLCP';
            }
            _self.bookingformcommon.preloader();
            $.ajax({
                    type: 'POST',
                    data:data,
                    url: linkandunlink,
                    success: function(msg:any) {
                    if(typeof msg==='string'){
                    msg = JSON.parse(msg);
                    }else{
                        msg=msg;
                    }
                    if(msg.errorCode=="OK")
                    {
                        _self.bookingformcommon.preloaderClose();
                        var cardnumber=$('#linkcard-number--acc').val();
                        var card=$("#linkcardName").val();
                        $('#'+card ).find('.user-details span').html(cardnumber);
                        $('#linkcard-number--acc').val('');
                        $("#linkcardName").val('');
                        $('#'+card ).find('.linkacc-connect-btn').removeClass('connect-btn');
                        $('#'+card ).find('.linkacc-connect-btn').addClass('btn-disconnect'); 
                        $('#'+card ).find('.linkacc-connect-btn span').html('Unlink');
                        if(card == "petronas"){
                            $('#'+card ).find('.linkacc-connect-btn').addClass('connect-btn');
                            $('#'+card ).find('.linkacc-connect-btn').removeClass('btn-disconnect'); 
                            $('#'+card ).find('.linkacc-connect-btn span').html('link');
                            $.magnificPopup.open({
                                items: {
                                    src: '#linkaccount-otp-popup'
                                },
                                type:'inline',
                                midClick: true,
                                closeBtnInside: false,
                                closeOnBgClick:false
                                });
                            $('#linkcard-setelnumber--acc').val(cardnumber);
                            } else {              
                                $.magnificPopup.close();
                            }               
                    }else{
                       _self.bookingformcommon.preloaderClose();
                        $("#errorMessage").show();
                        $.magnificPopup.close();
                    }
                    
                    },
                    error: function(error:any) {
                        _self.bookingformcommon.preloaderClose();
                        $.magnificPopup.close(); 
                        $("#errorMessage").show(); 
                    }
                });
            }
        });
        $("#errorMessage").hide();
    }
    unlinkaccount():any{
        $('.white-popuplogin .btn-loginacc--remove').click((evt: any) => {
            let _self = this;
            var card=$("#cardName").val();
            var cardnumber= $('#'+card ).find('span').html();
        let data:any = {
            'card' : card,
            'action':'unlink',
            'cardnumber' : cardnumber
            }
        $("#errorMessage").hide();
        let linkandunlink: string = '';
            if (window.location.hostname === 'localhost' && window.location.port == "5000") {
                linkandunlink = '/dummy-data/linkandunlink.json';
            }
            else {
                linkandunlink = '/bin/services/new/linkAndUnlinkLCP';
            }
        _self.bookingformcommon.preloader();
        $.ajax({
                type: 'POST',
                data:data,
                url: linkandunlink,
                success: function(msg:any) {
                if(typeof msg==='string'){
                msg = JSON.parse(msg);
                }else{
                    msg=msg;
                }
                if(msg.errorCode=="OK")
                {
                _self.bookingformcommon.preloaderClose();
                var card=$("#cardName").val();
                var cardnumber=$('#'+card ).find('span').html();
                $('#'+card ).find('.user-details span').html('Link');
                $('#'+card ).find('.linkacc-connect-btn').addClass('connect-btn');
                $('#'+card ).find('.linkacc-connect-btn').removeClass('btn-disconnect'); 
                $('#'+card ).find('.linkacc-connect-btn span').html('Link')
                $.magnificPopup.close()
                }else{
                     _self.bookingformcommon.preloaderClose();
                    $("#errorMessage").show();
                     $.magnificPopup.close();
                }               
                },
                error: function(error:any) {
                    _self.bookingformcommon.preloaderClose();
                    $("#errorMessage").show();
                    $.magnificPopup.close();
                }
            });
        });
    }
    setalConfirmaccount():any{
        $('.white-popuplogin .setal-confirm--link').click((evt: any) => {
            let _self = this;
            var cardnumber=$('#linkcard-setelnumber--acc').val();
            var card=$("#setelLinkCardName").val();
            var cardOTP=$("#linkcard-setelnumber--otp").val();
            if(cardnumber=="")
            {
                $('#linkcard-setelnumber--acc').addClass('has-error');
            }
            else{
            $('#linkcard-setelnumber--acc').removeClass('has-error');
            let data:any = {
                'card' : card,
                'action':'validateOTP',
                'cardNumber' : cardnumber,
                'otp': cardOTP
                }
            $("#errorMessage").hide();
            let linkandunlink: string = '';
            if (window.location.hostname === 'localhost' && window.location.port == "5000") {
                linkandunlink = '/dummy-data/linkandunlink.json';
            }
            else {
                linkandunlink = '/bin/services/new/sendMESRAOTPVerification';
            }
            _self.bookingformcommon.preloader();
            $.ajax({
                    type: 'POST',
                    data:data,
                    url: linkandunlink,
                    success: function(msg:any) {
                    if(typeof msg==='string'){
                    msg = JSON.parse(msg);
                    }else{
                        msg=msg;
                    }
                    if(msg.errorCode=="OK")
                    {
                        _self.bookingformcommon.preloaderClose();
                        var cardnumber=$('#linkcard-setelnumber--acc').val();
                        var card=$("#setelLinkCardName").val();
                        $('#'+card ).find('.user-details span').html(cardnumber);
                        $('#linkcard-setelnumber--acc').val('');
                        $("#setelLinkCardName").val('');
                        $('#'+card ).find('.linkacc-connect-btn').removeClass('connect-btn');
                        $('#'+card ).find('.linkacc-connect-btn').addClass('btn-disconnect'); 
                        $('#'+card ).find('.linkacc-connect-btn span').html('Unlink');
                        $('#'+card ).find('.linkacc-connect-btn').addClass('disable'); 
                        $("#errorMsgPetronas").hide();
                        $('.error_msg_petronas').removeClass('show');
                        $('.error_msg_petronas').addClass('hide');
                        $('.succ_msg_petronas').addClass('show');
                        $('.succ_msg_petronas').removeClass('hide');
                        $("#succMsgPetronas").show();
                        // $('#'+card ).find('.linkacc-connect-btn span').unbind("click");
                        // $('#'+card ).find('.linkacc-connect-btn span').css("background", "#e3d9d9"); 
                        // $('#'+card ).find('.linkacc-connect-btn span').css("pointer-events", "none"); 
                        $.magnificPopup.close();              
                    }else{
                       _self.bookingformcommon.preloaderClose();
                        $("#errorMsgPetronas").show();
                        $("#succMsgPetronas").hide();
                        $('.error_msg_petronas').removeClass('hide');
                        $('.error_msg_petronas').addClass('show');
                        $('.succ_msg_petronas').addClass('hide');
                        $('.succ_msg_petronas').removeClass('show');
                        $.magnificPopup.close();
                    }
                    
                    },
                    error: function(error:any) {
                        _self.bookingformcommon.preloaderClose();
                        $.magnificPopup.close(); 
                        $("#errorMessage").show(); 
                    }
                });
            }
        });
        $("#errorMessage").hide();
    }
	cancelpopup():any
	{
		let _self = this;
		$('.white-popuplogin .btn-loginacc--cancel').click((evt: any) => {
		$.magnificPopup.close()
		 $(window).unbind('scroll');
		 evt.preventDefault();
         evt.stopPropagation();
		});
	}

}
let scope:Element = document.querySelector('#members--lcplogin--details');

if (scope) {
	try {
    let loginAccount = new loginDetails();
    var adobeDataLayer = new adobeDataLayerWrapper();
    loginAccount.buttonConnect();
    loginAccount.cancelpopup();
    loginAccount.linkaccount();
    loginAccount.unlinkaccount();
    loginAccount.setalConfirmaccount();
    loginAccount.editOtpLoginFlow();
    loginAccount.editOtpOption();
    adobeDataLayer.push('pageLoaded', {
        'pageName': '',
        'pageType': 'Enrich Profile - Enrich Account Settings',
        'attributes': []
    });
	} catch(e) {console.error(e);}
}